'use client'

import Image from 'next/image'
import { useMemo } from 'react'

const FAVORITES_IMAGES = [
    '/images/hive-diptych-favorites-vitra-girard-heart.jpg',
    '/images/hive-diptych-favorites-vitra-panton-heart.jpg',
]

const FavoritesModalImage = ({ alt = 'Favorites' }) => {
    // Select a random image once when the component mounts
    const imageSrc = useMemo(() => {
        const randomIndex = Math.floor(Math.random() * FAVORITES_IMAGES.length)
        return FAVORITES_IMAGES[randomIndex]
    }, [])

    return (
        <div className="w-full md:w-1/2 relative flex-1 min-h-[250px] md:min-h-0 md:flex-none order-2 md:order-1 p-0 m-0">
            <Image
                src={imageSrc}
                alt={alt}
                fill
                quality={90}
                sizes="(max-width: 768px) 100vw, 50vw"
                className="object-cover"
            />
        </div>
    )
}

export default FavoritesModalImage
